const orderStatusDelivery = {
    "5": [ "Accepted by seller", "Seller transfers the item to delivery partner", "5"],
    "6": [ "Pick", "Picked by delivery partner", "6"],
    "7": [ "On the way", "On the way", "7" ],
    "8": [ "Reached", "Reached to user", "8" ],
    "9": [ "Delivered", "Delivered to user by delivery partner", "9"],
    "10": [ "Payment Received", "Payment received by delivery partner in case of COD (successful delivery)", "10"],
    "12": [ "Cancel", "Canceled by delivery partner", "12"],
    "13": [ "Cancel by user", "Canceled by user after delivery partner reaches and before COD payment", "13"],
    "16": [ "On the way to receive items from user", "Delivery partner is on the way in case of cancellation (after successful delivery)", "16"],
    "17": [ "Receive item from user", "Delivery partner receives items in case of cancellation (after successful delivery) (successful refund initiation)", "17"],
    "18": [ "Return cash from user ", "Delivery partner returns cash in case of cancellation (after successful delivery) (successful cancellation done)", "18"]
};

module.exports = orderStatusDelivery;